import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getContatos, { getAllContatos, getContato } from "../queries/getContatos";

export default function useGetContatos(search?: string, page: number = 1) {
  const resultQuery = useQuery([`${URLS.CONTATO_API}`, {
    params: { search, page }
  }],
    () => getContatos(search, page)
  );

  return resultQuery;
}

export function useGetContato(contatoId: number) {
  const resultQuery = useQuery([`${URLS.CONTATO_API}/${contatoId}`], () => getContato(contatoId))

  return resultQuery;
}

export function useGetAllContatos(search?: string) {
  const resultQuery = useQuery(
    search ? [`${URLS.CONTATO_API}?search=${search}`] : [URLS.CONTATO_API],
    () => getAllContatos(search),
    {
      onSuccess: (data) => {
        // console.log(data);
        return data;
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return resultQuery;
}
